<template>
  <!-- 矿发数据 -->
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">矿发数据</div>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label="">
          <el-input v-model="filterForm.id" type="number" placeholder="序号" clearable></el-input>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.coalMineNo" clearable filterable placeholder="矿发名称">
            <el-option
              v-for="item in allCoalmineList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.collectStationNo" clearable filterable placeholder="收货名称">
            <el-option
              v-for="item in stationList"
              :key="item.collectStationNo"
              :label="item.collectStationName"
              :value="item.collectStationNo"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.tmdNo" placeholder="提煤单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.mjpNo" placeholder="煤检票号" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.mineSendPoundNo" placeholder="矿发磅单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.createUser" placeholder="驻矿id" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.carLicensePlateNo" placeholder="车牌号" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.driverPhone" placeholder="手机号" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label>
          <el-select v-model="filterForm.transStatus" clearable placeholder="补录状态">
            <el-option
              v-for="item in supplyStatusList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label>
          <el-select v-model="filterForm.matchFlag" clearable placeholder="匹配状态">
            <el-option
              v-for="item in matchStatusList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.revokeFlag" clearable placeholder="是否作废">
            <el-option
              v-for="item in revokeStatusList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            v-model="filterForm.createTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-sign-out"
            label="导出"
            v-loading.fullscreen.lock="fullscreenLoading"
            perms="31200"
            type="primary"
            @click="handleExport"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table
      v-loading="loading"
      :data="financeList"
      stripe
      size="mini"
      style="width: 100%;"
      row-key="flowNo"
    >
      <el-table-column
        prop="id"
        width="80"
        align="center"
        fixed
        label="序号">
      </el-table-column>
      <el-table-column
        prop="coalMineName" 
        align="center" 
        label="矿发名称">
      </el-table-column>
      <el-table-column
        width="180px"
        prop="collectStationName" 
        align="center" 
        label="收货名称">
      </el-table-column>
      <el-table-column
        prop="tmdNo"
        align="center"
        label="提煤单号">
      </el-table-column>
      <el-table-column
        prop="carLicensePlateNo"
        align="center"
        label="车辆号">
      </el-table-column>
      <el-table-column
        width="120"
        prop="driverPhone"
        align="center"
        label="司机电话">
      </el-table-column>
      <el-table-column
        prop="driverName"
        align="center"
        label="司机姓名">
      </el-table-column>
      <el-table-column
        prop="mjpNo"
        width="120"
        align="center"
        label="煤检票号">
      </el-table-column>
      <el-table-column
        prop="mineSendPoundNo"
        align="center"
        label="矿发磅单号">
      </el-table-column>
      <el-table-column
        prop="mineSendTareWeight"
        align="center"
        label="皮重">
      </el-table-column>
      <el-table-column
        prop="mineSendGrossWeight"
        align="center"
        label="毛重">
      </el-table-column>
      <el-table-column
        prop="mineSendNetWeight"
        align="center"
        label="净重">
      </el-table-column>
      <el-table-column
        prop="dataSourceDesc"
        align="center"
        label="取值来源">
      </el-table-column>
      <el-table-column
        prop="createUser"
        width="120"
        align="center"
        label="驻矿id">
      </el-table-column>
      <el-table-column
        width="150px"
        prop="createTime"
        align="center"
        label="生成时间">
      </el-table-column>
      <el-table-column
        width="150px"
        prop="supplyTime"
        align="center"
        label="补录时间">
      </el-table-column>
      <el-table-column
        prop="matchFlagDesc" 
        align="center" 
        label="状态">
      </el-table-column>
      <el-table-column
        prop="revokeFlagDesc" 
        align="center"
        label="是否作废">
          
      </el-table-column>
      <el-table-column
        width="200"
        prop="remark" 
        align="center" 
        label="备注">
      </el-table-column>
      <el-table-column
        width="250"
        align="center" 
        label="补录图片">
          <template slot-scope="scope">
            <el-image
              class="recordingImg"
              v-for="(item, index) in scope.row.phoneImgList"
              :key="index"
              :src="item"
              :preview-src-list="scope.row.phoneImgList"
            ></el-image>
          </template>
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding:20px;">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float:right;padding: 10px;"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";

let that = null;
export default {
  components: {
    KtButton
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
      fullscreenLoading: false,
      searchLoading: false,
      financeList: [],
      allCoalmineList: [],
      stationList: [],
      supplyStatusList: [], // 补录状态
      matchStatusList: [
        {name: '已匹配', code : '1'},
        {name: '未匹配', code : '0'}
      ],
      revokeStatusList: [
        {name: '未作废', code : '0'},
        {name: '已作废', code : '1'}
      ],
      statusList: [
        {name: '交易中', code : '0'},
        {name: '交易成功', code : '1'},
        {name: '交易失败', code : '2'},
      ],
      filterForm: {}
    };
  },
  created() {
  },
  mounted() {
    this.getCoalSendData();
    this.getAllCoalmineList();
    this.getAllStationList();
  },
  methods: {
    // 获取所有煤矿
    getAllCoalmineList() {
      this.$api.finance.getAllCoalmineList().then(res => {
        if (res.data && res.data.length > 0) {
          this.allCoalmineList = res.data;
        } else {
          this.allCoalmineList = [];
        }
      });
    },

    // 获取所有集运站
    async getAllStationList(){
      let res = await this.$api.station.mGetStationList({
        pageNo: 1,
        pageSize: 1000,
      })
      if(res.data.dtoList){
        this.stationList = res.data.dtoList;
      } else {
        this.stationList = []
      }
      
    },

    // 获取矿发数据
    async getCoalSendData() {
      this.loading = true;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "createTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = `${val[0]} 00:00:00`;
            params["searchFieldList[" + index + "].rangeMaxValue"] = `${val[1]} 23:59:59`;
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.dataModel.mGetCoalSendData(params);
      const data = res.data;
      this.totalSize = data.totalSize || 0;
      if (data && data.dtoList && data.dtoList.length > 0) {
        let dtoList = data.dtoList;
        dtoList.map(item => {
          if(item.photo){
            item.phoneImgList = item.photo.split(',')
          }
        })

        this.financeList = dtoList;
      } else {
        this.financeList = [];
      }
      this.loading = false;
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getCoalSendData();
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getCoalSendData();
    },
    handleReset() {
      this.filterForm = {};
      this.handleSearch();
    },
    
    // 导出
    handleExport() {
      this.fullscreenLoading = true;
      const params = {
        pageNo: 1,
        pageSize: 10000
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "createTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = `${val[0]} 00:00:00`;
            params["searchFieldList[" + index + "].rangeMaxValue"] = `${val[1]} 23:59:59`;
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      this.$api.dataModel.mGetCoalSendData(params).then(res => {
        const data = res.data;
        if (data && data.dtoList && data.dtoList.length > 0) {
          const list = this.exportFormat(data.dtoList);
          this.exportExcel(list);
          this.fullscreenLoading = false;
        } else {
          this.$message({ message: "暂无数据" });
          this.fullscreenLoading = false;
        }
      });
    },
    exportExcel(list) {
      const _t = this
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../utils/Export2Excel");
        const tHeader = [
          "序号",
          "矿发名称",
          "收获名称",
          "提煤单号",
          "车辆号",
          "司机电话",
          "司机姓名",
          "煤检票号",
          "矿发磅单号",
          "皮重",
          "净重",
          "取值来源",
          "驻矿id",
          "生成时间",
          "补录时间",
          "状态",
          "是否作废",
          "备注"
        ]; // 设置Excel的表格第一行的标题
        const filterVal = [
          "id",
          "coalMineName",
          "collectStationName",
          "tmdNo",
          "carLicensePlateNo",
          "driverPhone",
          "driverName",
          "mjpNo",
          "mineSendPoundNo",
          "mineSendTareWeight",
          "mineSendNetWeight",
          "dataSourceDesc",
          "coalMineNo",
          "createTime",
          "supplyTime",
          "arriveFlagDesc",
          "revokeFlagDesc",
          "remark"
        ];
        const data = _t.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "矿发数据"); //导出Excel 文件名
      });
    },
    // 导出时类型转化
    exportFormat(res) {
      const list = res;
      list.forEach((item, index) => {
        item["index"] = index + 1;
        item["remark"] = item["remark"] || "无";
      });
      return list;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}
.recordingImg{
  width: auto;
  height: 50px;

  ::v-deep .el-image__inner {
    width: auto;
    height: 50px;
  }
}
</style>
